export default [
  {
    path: '/rent/v2/test',
    name: 'test',
    component: () => import('@/pages/test/index'),
    meta: { title: '测试', requireAuth: true },
  },
]


// WEBPACK FOOTER //
// ./src/pages/test/test.js